module.exports = __webpack_public_path__ + "assets/img/block-left-hover-47cc6284.png";